import React from 'react';

import type { SpacePermission } from '../../../model/space-roles-types.ts';
import { PermissionDescriptionTooltip } from '../PermissionDescriptionTooltip.tsx';

/**
 * Builds the extra permission content map for permissions that have a description.
 * Used to show an info tooltip next to permissions whose API node includes description or hubDescription.
 */
export const buildPermissionDescriptionTooltips = (
	allPermissions: SpacePermission[],
): Record<string, React.ReactNode> =>
	Object.fromEntries(
		allPermissions
			.filter((p) => p.description?.trim())
			.map((p) => [
				p.key,
				<PermissionDescriptionTooltip key={p.key} description={p.description} />,
			]),
	);
